import React, {Component} from 'react';
import {Switch, Route, withRouter, Redirect} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Sales extends Component {
	constructor(props)
    {
        super(props);
        this.state = {
            USER: this.props.USER
        }
    }



    componentDidUpdate(prevProps, prevState, snapshot)
    {

        if (this.props.USER !== prevProps.USER) {
            this.setState({USER: this.props.USER});
        }
    }



    render() {
        if (!this.state.USER) {
            return <Redirect to="/"/>
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>Продажи</title>
                </Helmet>
                <h1>Продажи</h1>
            </div>
        );
	}
}

export default withRouter(connect(
	mapStateToProps, mapDispatchToProps
)(Sales))
